// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LayoutFilledSvg from "@ant-design/icons-svg/es/asn/LayoutFilled";
import AntdIcon from '../components/AntdIcon';

var LayoutFilled = function LayoutFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LayoutFilledSvg
  }));
};

LayoutFilled.displayName = 'LayoutFilled';
export default React.forwardRef(LayoutFilled);